import React from "react";
import { FilePicker } from 'react-file-picker'
import translateString from "../utils/Locales";

let t = translateString;

export default class ImageSilentInput extends React.Component {

    constructor (props){
        super(props);

        this.state = {
            base64: this.props.value
        }
    }

    render (){
        return ( 
        <div>
            <div style={name}>{this.props.name}</div>

            <FilePicker
                extensions={['jpg', 'jpeg', 'png', 'pdf']}
                onChange={file => {

                    this.getBase64(file, this.props.onChange);

                }}
                onError={errMsg => {
                } } >

                <div style={{ ...name, display: 'flex', alignItems:'center',}}>
                    <img style={{ width: 15, height: 15 }} src={ require('../images/add_doc.png') } alt="Add" />
                    <p style={{ marginLeft:5,marginTop:16, color: '#4EBE24', fontWeight: 'bold' }}>{t('aggiungi')}</p>
                </div>
            
            </FilePicker>
        </div>
        )
    }

    getBase64(file, cb) {
        let reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = function () {
            cb(reader.result)
        };
        reader.onerror = function (error) {
            console.log('Error: ', error);
        };
    }

}


const name = {
    cursor: 'pointer',
}